import React, {useEffect, useState, useRef, useMemo} from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import {FormattedMessage, injectIntl, useIntl} from 'react-intl';
import {connect, useDispatch} from 'react-redux';
import {RootState} from '../../reducers';
import * as actions from '../../actions/generalActions';
import * as offerActions from '../../actions/offers';
import {resetOfferClient} from '../../actions/offers';
import * as clientActions from '../../actions/client';
import {resetClient} from '../../actions/client';
import * as measuresActions from '../../actions/measures'
import * as adminActions from '../../actions/admin';
import {withRouter} from 'react-router';
import {Input} from '../../components/Input/Input';
import {Button, EButtonType} from '../../components/Button';
import './Offers.scss'
import {Client} from '../../types/client.type';
import {toast} from 'react-toastify';

import Spinner from '../../components/Spinner';
import MikaSelect from '../../components/BbrosSelect/mikaSelect.component';
import {SelectOption} from '../../types/selectOption.type';
import {FileUpload} from '../../types/fileUpload.type';
import {OfferField} from '../../types/offerField.type';
import DataTransferComponent from "../../components/DataTransferComponent/DataTransferComponent";
import arrowDown from '../../assets/icons/Icon_awesome_arrow_alt_circle_right.svg'
import {useParams} from "react-router-dom";
import {Asset} from "../../types/asset.type";
import {isMobile, OFFER_STATUSES, FETCHED_CLIENT, FETCH_CLIENT_OFFERS} from "../../constants/constants";
import MikaFileInput from "../../components/Input/MikaFileInput/MikaFileInput";
import MikaFileManager from "../../components/MikaFileManager/MikaFileManager";
import '../Agreements/Agreements.scss';
import CalculateOfferModal from "./CalculateOfferModal/CalculateOfferModal";
import FontAwesome from 'react-fontawesome'
import {ParameterTypes} from '../../types/parameter.type';
import {checkIfUserIsAuthorized} from "../Admin/globalFunctions";
import PICFile from "../../assets/icons/pic.svg";
import DifferentColoredPlus from "../../assets/icons/differentColoredPlus.svg";
import {axiosCaller, apiCaller, apiUrl} from "../../utils/apiCaller";
import {OfferProduct} from "../../types/offerProduct.type";
import moment from "moment";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import MentionInput from '../../components/MentionInput/MentionInput';
import MentionText from '../../components/MentionInput/MentionText';
import MikaConfirmModal from '../../components/MikaConfirmModal/MikaConfirmModal';

interface Props {
    intl: any;
    loading: boolean;
    history: any;
    client: any;
    clientActions: any;
    offerActions: any;
    measuresActions: any;
    actions: any,
    offers: any,
    measures: any,
    letter: string,
    clientsByModuleData: Array<Client>,
    allClients: SelectOption[],
    allOfferFields: OfferField[],
    adminActions: any,
    admin: any,
    permissions: any,
    projectName: string
    buttonLoader: boolean
    projectDetails: any
    companyProfile?: any
}

// ── Month-browsing calendar header ────────────────────────────────────────────
// Month names come from Intl.DateTimeFormat at render time, using the current
// react-intl locale — so they retranslate when the user switches language.
interface CalendarHeaderProps {
    date: Date; changeYear: (y: number) => void; changeMonth: (m: number) => void;
    decreaseMonth: () => void; increaseMonth: () => void;
    prevMonthButtonDisabled: boolean; nextMonthButtonDisabled: boolean;
}
const CalendarHeader: React.FC<CalendarHeaderProps> = ({
    date, changeYear, changeMonth, decreaseMonth, increaseMonth,
    prevMonthButtonDisabled, nextMonthButtonDisabled
}) => {
    const { locale } = useIntl();
    const [showMonths, setShowMonths] = useState(false);
    const headerRef = useRef<HTMLDivElement>(null);
    const year = date.getFullYear();
    const month = date.getMonth();

    const MONTHS = useMemo(() => {
        const fmt = new Intl.DateTimeFormat(locale, { month: 'long' });
        return Array.from({ length: 12 }, (_, i) =>
            fmt.format(new Date(2000, i, 1)).replace(/^./, c => c.toUpperCase())
        );
    }, [locale]);

    useEffect(() => {
        const cal = headerRef.current?.closest('.react-datepicker') as HTMLElement | null;
        if (!cal) return;
        const container = cal.querySelector('.react-datepicker__month-container') as HTMLElement | null;
        if (showMonths) {
            cal.classList.add('month-picker-active');
        } else {
            cal.classList.remove('month-picker-active');
            if (container) container.style.minHeight = '';
        }
    }, [showMonths]);

    function openMonthPicker() {
        const cal = headerRef.current?.closest('.react-datepicker') as HTMLElement | null;
        const container = cal?.querySelector('.react-datepicker__month-container') as HTMLElement | null;
        if (container) container.style.minHeight = container.offsetHeight + 'px';
        setShowMonths(true);
    }

    if (showMonths) return (
        <div ref={headerRef} className="dp-header dp-header--months">
            <div className="dp-year-nav">
                <button type="button" className="dp-nav-btn" onClick={() => changeYear(year - 1)}>‹</button>
                <span className="dp-year-label">{year}</span>
                <button type="button" className="dp-nav-btn" onClick={() => changeYear(year + 1)}>›</button>
            </div>
            <div className="dp-month-grid">
                {MONTHS.map((m, i) => (
                    <button type="button" key={m}
                        className={`dp-month-btn${month === i ? ' active' : ''}`}
                        onClick={() => { changeMonth(i); setShowMonths(false); }}>
                        {m}
                    </button>
                ))}
            </div>
        </div>
    );
    return (
        <div ref={headerRef} className="dp-header">
            <button type="button" className="dp-nav-btn" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>‹</button>
            <button type="button" className="dp-month-year-btn" onClick={openMonthPicker}>
                {MONTHS[month]} {year} <span className="dp-chevron">▾</span>
            </button>
            <button type="button" className="dp-nav-btn" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>›</button>
        </div>
    );
};

const Offers = (props: Props) => {
    const fm = (id: string, defaultMessage: string, values?: Record<string, any>) =>
        props.intl.formatMessage({ id, defaultMessage }, values);

    const {offerId, projectId} = useParams<ParameterTypes>();
    const [loading, setLoading] = useState<boolean>(false);
    const [isDeleteModalOpen, setDeleteModal] = useState<boolean>(false);
    const [firstAndLastName, setFirstAndLastName] = useState<string>('');
    const [offerStatus, setOfferStatus] = useState<SelectOption>()
    const [addition, setAddition] = useState<string>('')
    const [finalOfferFile, setFinalOfferFile] = useState<FileUpload[]>([] as FileUpload[])
    const [requirementsFile, setRequirementsFile] = useState<FileUpload[]>([] as FileUpload[])
    const [pdfFile, setPdfFile] = useState<FileUpload[]>([] as FileUpload[])
    const [searchedClient, setSearchedClient] = useState<string>()
    const [clients, setClients] = useState<SelectOption[]>([])
    const [allOfferFields, setAllOfferFields] = useState<OfferField[]>([])
    const [isDropDownInfoOpen, setIsDropDownInfoOpen] = useState(false);
    const [offerAssets, setOfferAssets] = useState([])
    const [offerComments, setOfferComments] = useState<any[]>([])
    const [newOfferComment, setNewOfferComment] = useState('')
    const [offerConditions, setOfferConditions] = useState<string>()
    const [isSelectMode, setIsSelectMode] = useState(false)
    const [filesLoading, setFilesLoading] = useState(false)
    const [selectedAssets, setSelectedAssets] = useState<Set<number>>(new Set())
    const [pendingDeleteId, setPendingDeleteId] = useState<number|null>(null)
    const [pendingBulkDeleteIds, setPendingBulkDeleteIds] = useState<number[]>([])
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [productsLoading, setProductsLoading] = useState<boolean>(false)
    const [products, setProducts] = useState<OfferProduct[]>([{} as OfferProduct])
    const [openingModal, setOpeningModal] = useState<boolean>(false)

    // New fields for Point of Contact and Installation Date
    const [pointOfContact, setPointOfContact] = useState<SelectOption>({} as SelectOption)
    const [installationDate, setInstallationDate] = useState<Date | null>(null)
    const [originalInstallationDate, setOriginalInstallationDate] = useState<Date | null>(null)
    const [isOfferApproved, setIsOfferApproved] = useState<boolean>(false)
    const [pocUsers, setPocUsers] = useState<SelectOption[]>([])
    const [installationDateHistory, setInstallationDateHistory] = useState<any[]>([])
    const [showInstallationHistory, setShowInstallationHistory] = useState<boolean>(false)
    const [showInstallationDateModal, setShowInstallationDateModal] = useState<boolean>(false)
    const [installationDateComment, setInstallationDateComment] = useState<string>('')

    // KuBIT sale-order push: persisted status (loaded from complete-details) +
    // an in-flight flag for the Push-to-KuBIT button.
    const [kubitSaleOrder, setKubitSaleOrder] = useState<{ pushed: boolean; saleOrderId: string | null } | null>(null)
    const [pushingToKubit, setPushingToKubit] = useState<boolean>(false)
    // Names of raw materials not yet synced to KuBIT — non-empty opens the
    // "push without them" confirm dialog on a components_not_synced push result.
    const [unsyncedComponents, setUnsyncedComponents] = useState<string[]>([])

    // Use refs instead of state for synchronous updates to avoid race conditions
    const productsLoadedFromUnified = useRef<boolean>(false);
    const currentShipmentDestinationId = useRef<number | null>(null);
    const currentOfferId = useRef<number | null>(null);

    const dispatch = useDispatch();

    useEffect(() => {
        props.actions.fetchOfferFields()
        props.adminActions.getOfferConditions()
        props.actions.fetchCompanyProfile()

        // Fetch POC users (admins + users with offer permission)
        axiosCaller('GET', 'users/offer-poc-users').then((res) => {
            // Backend already returns {value, label} format
            setPocUsers(res.data.data);
        }).catch((err) => {
            console.error('Error fetching POC users:', err);
        });
    }, [])

    useEffect(()=>{
        props.actions.getAllProjectInfo('',projectId)
    },[projectId])

    useEffect(() => {
        if (Object.keys(props.permissions).length !== 0 && !checkIfUserIsAuthorized(props.permissions, props.permissions?.fullPrivileges, props.permissions?.offers)) {
            toast.error(fm('offer.toast.notAuthorized', 'You do not have permission to modify data in this module.'))
            props.history.push('/dashboard/offer')
        }
    }, [props.permissions])

    useEffect(() => {
        const isExport = props.projectDetails?.shipmentDestinationId === 2;
        const conditions = isExport
            ? props.admin?.offerConditions?.conditionsExport
            : props.admin?.offerConditions?.conditions;
        setOfferConditions(conditions || '')
    }, [props.admin.offerConditions, props.projectDetails?.shipmentDestinationId])

    useEffect(() => {
        // Merge field definitions (names) with any existing values already loaded from the offer
        // If all definitions were deleted, this clears the fields entirely
        if (!props?.allOfferFields?.length) {
            setAllOfferFields([])
            return
        }
        setAllOfferFields(prev => {
            return props.allOfferFields.map(fieldDef => {
                const existing = prev?.find(f => f.id === fieldDef.id)
                return {
                    ...fieldDef,
                    value: existing?.value || fieldDef.value || ''
                }
            })
        })
    }, [props?.allOfferFields])

    useEffect(() => {
        let tempArrayOfClients = props.allClients

        tempArrayOfClients = tempArrayOfClients.filter(val => val.name.includes(searchedClient?.charAt(0).toUpperCase()))

        setClients(tempArrayOfClients)

    }, [searchedClient])

    useEffect(() => {
        getProductsOfClient()
    }, [props.client?.client?.id])

    //
    // useEffect(() => {
    //     setClients(props.allClients)
    // }, [props.allClients])

    useEffect(() => {
        console.log('offerId changed to:', offerId);
        // Reset the flag when offerId changes so getProductsOfClient can work for next offer
        productsLoadedFromUnified.current = false;
        getModuleData()
        if (offerId) loadOfferComments()
    }, [offerId])

    function loadOfferComments() {
        if (!offerId) return;
        props.offerActions.getOfferComments(Number(offerId)).then((res: any) => {
            if (res?.data) setOfferComments(res.data);
        });
    }

    const handleAddOfferComment = () => {
        if (!newOfferComment.trim() || !offerId) return;
        props.offerActions.addOfferComment(Number(offerId), newOfferComment.trim()).then((res: any) => {
            const comment = res?.data?.data || res?.data;
            if (comment) {
                setOfferComments(prev => [...prev, comment]);
                setNewOfferComment('');
            }
        });
    };

    const handleDeleteOfferComment = (commentId: number) => {
        props.offerActions.deleteOfferComment(commentId).then(() => {
            setOfferComments(prev => prev.filter(c => c.id !== commentId));
        });
    };

    useEffect(() => {
        console.log('PRODUCTS STATE CHANGED:', products);
    }, [products])

    function getProductsOfClient() {
        console.log('========== getProductsOfClient CALLED ==========');
        console.log('productsLoadedFromUnified.current:', productsLoadedFromUnified.current);
        console.log('currentShipmentDestinationId.current (REF):', currentShipmentDestinationId.current);
        console.log('currentOfferId.current (REF):', currentOfferId.current);
        console.log('props.projectDetails?.shipmentDestinationId (STALE REDUX):', props.projectDetails?.shipmentDestinationId);
        console.log('props.client?.client?.id:', props.client?.client?.id);
        console.log('props.offers?.offerClient?.id (STALE REDUX):', props.offers?.offerClient?.id);

        // Reset flag if products were already loaded from unified endpoint
        if (productsLoadedFromUnified.current) {
            console.log('Resetting productsLoadedFromUnified flag for article products');
            productsLoadedFromUnified.current = false;
        }

        let tempProducts = []
        if (props.client?.client?.id) {
            // Use currentOfferId.current (ref) instead of props.offers?.offerClient?.id (stale Redux)
            console.log('Calling API: products/clients/' + props.client?.client?.id + '?offerId=' + currentOfferId.current);
            setProductsLoading(true)
            axiosCaller('GET', `products/clients/${props.client?.client?.id}${currentOfferId.current ? `?offerId=${currentOfferId.current}` : ``}`).then((res) => {
                tempProducts = res.data.data
                console.log('getProductsOfClient API RETURNED:', tempProducts);
                console.log('getProductsOfClient: Number of products:', tempProducts.length);
                tempProducts.forEach((p, idx) => {
                    console.log(`getProductsOfClient Product ${idx}:`, {
                        id: p.id,
                        offerId: p.offerId,
                        materialId: p.materialId,
                        designation: p.designation,
                        responsibilities: p.responsibilities
                    });
                });
                if (tempProducts.length !== 0) {
                    console.log('getProductsOfClient: Setting products to:', tempProducts);
                    setProducts(tempProducts)
                } else {
                    setProducts(
                        [{
                            designation: {
                                label: '',
                                value: 0
                            },
                            discount: 0,
                            price: 0,
                            tax: 0,
                            taxPrice: 0,
                            type: '',
                            unit: 0,
                            value: 0
                        }]
                    )
                }
                setProductsLoading(false)
            }).catch(() => setProductsLoading(false));
        }
    }

    async function openModalWithFreshData() {
        console.log('========== openModalWithFreshData CALLED ==========');
        setOpeningModal(true);

        // Fetch fresh data from unified endpoint
        try {
            const response: any = await apiCaller('GET', `offers/${offerId}/complete-details`);
            const res = response;
            console.log('MODAL OPEN: Fetched fresh data for offer', offerId);

            // Store refs
            currentShipmentDestinationId.current = res.data.project?.shipmentDestinationId || null;
            currentOfferId.current = res.data.offer?.id || null;
            productsLoadedFromUnified.current = true;

            // Set products
            if (res.data.products && res.data.products.length > 0) {
                console.log('MODAL OPEN: Setting products:', res.data.products);
                setProducts(res.data.products);
            } else {
                setProducts([{
                    designation: { label: '', value: 0 },
                    discount: 0,
                    price: 0,
                    tax: 0,
                    taxPrice: 0,
                    type: '',
                    unit: 0,
                    value: 0
                } as OfferProduct]);
            }

            setOpeningModal(false);
            setDeleteModal(true);
        } catch (error) {
            console.error('Error fetching data for modal:', error);
            setOpeningModal(false);
            toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'));
        }
    }

    function getModuleData(){
        console.log('========== getModuleData CALLED for offerId:', offerId, '==========');
        setLoading(true)
        if (offerId) {
            // Use unified endpoint to get all data in one call
            apiCaller('GET', `offers/${offerId}/complete-details`).then((response: any) => {
                const res = response;
                console.log('UNIFIED ENDPOINT RESPONSE for offer', offerId, ':', res.data);
                console.log('Project shipmentDestinationId:', res.data.project?.shipmentDestinationId);

                // Store the CURRENT shipmentDestinationId and offerId in refs for synchronous access
                // This prevents using stale Redux props and avoids race conditions
                const shipmentDestId = res.data.project?.shipmentDestinationId || null;
                currentShipmentDestinationId.current = shipmentDestId;
                console.log('Set currentShipmentDestinationId.current to:', shipmentDestId);

                const currentOfferIdValue = res.data.offer?.id || null;
                currentOfferId.current = currentOfferIdValue;
                console.log('Set currentOfferId.current to:', currentOfferIdValue);

                // IMPORTANT: Set this flag FIRST before dispatching Redux actions
                // This prevents the useEffect(props.client?.client?.id) from making duplicate API call
                // Using ref for synchronous update
                productsLoadedFromUnified.current = true;
                console.log('Set productsLoadedFromUnified.current = true');

                // Set products from unified endpoint BEFORE dispatching Redux
                console.log('UNIFIED API returned products for offer', offerId, ':', res.data.products);
                console.log('UNIFIED API: Number of products:', res.data.products?.length);
                if (res.data.products && res.data.products.length > 0) {
                    res.data.products.forEach((p, idx) => {
                        console.log(`UNIFIED Product ${idx}:`, {
                            id: p.id,
                            offerId: p.offerId,
                            materialId: p.materialId,
                            designation: p.designation,
                            responsibilities: p.responsibilities
                        });
                    });
                    console.log('UNIFIED: Setting products to:', res.data.products);
                    setProducts(res.data.products)
                } else {
                    console.log('UNIFIED: No products, setting empty product');
                    setProducts([{
                        designation: {
                            label: '',
                            value: 0
                        },
                        discount: 0,
                        price: 0,
                        tax: 0,
                        taxPrice: 0,
                        type: '',
                        unit: 0,
                        value: 0
                    } as OfferProduct])
                }

                // Dispatch client data to Redux with correct structure
                dispatch({
                    type: FETCHED_CLIENT,
                    payload: { data: res.data.client }
                });

                // Dispatch offer data to Redux with correct structure
                dispatch({
                    type: FETCH_CLIENT_OFFERS,
                    payload: { data: res.data.offer }
                });

                // Set client name
                if (res.data.client) {
                    setFirstAndLastName(`${res.data.client?.firstnameAndLastname} ${res.data.client?.lastName}`)
                }

                // Set offer-related local state
                props.offerActions.setDiscountValue(res.data.offer?.discountValue)
                props.offerActions.setDiscountType({value: res.data.offer?.discountType})
                setOfferStatus(res.data.offer?.offerStatus)
                setAddition(res.data.offer?.addition)
                // Merge offer's saved values with field definitions (which have names)
                const savedFields = res.data.offer?.dynamicFields || []
                if (props?.allOfferFields?.length) {
                    // Field definitions already loaded — merge values into them
                    setAllOfferFields(props.allOfferFields.map(fieldDef => {
                        const saved = savedFields.find((f: any) => f.id === fieldDef.id)
                        return { ...fieldDef, value: saved?.value || '' }
                    }))
                } else {
                    // Field definitions not yet loaded — store values, they'll be merged when definitions arrive
                    setAllOfferFields(savedFields)
                }

                // Set Point of Contact and Installation Date
                if (res.data.offer?.pointOfContact) {
                    setPointOfContact(res.data.offer.pointOfContact)
                }
                if (res.data.offer?.installationDate) {
                    // Convert from dd/mm/yyyy to Date object for DatePicker
                    const parts = res.data.offer.installationDate.split('/')
                    if (parts.length === 3) {
                        // parts[0] = day, parts[1] = month, parts[2] = year
                        const dateObj = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
                        setInstallationDate(dateObj)
                        setOriginalInstallationDate(dateObj)
                    }
                }
                // Check if offer is approved (status id = 2)
                setIsOfferApproved(res.data.offer?.offerStatus?.value === 2)

                // KuBIT sale-order push status ({ pushed, saleOrderId }). The
                // resource always includes it; pushed=false until the offer has
                // been pushed. The button itself is gated by companyProfile.kubitEnabled.
                setKubitSaleOrder(res.data.offer?.kubitSaleOrder || null)

                if (res.data.offer?.installationDateHistory) {
                    setInstallationDateHistory(res.data.offer.installationDateHistory)
                }

                // Set offer files
                let tempArray = []
                res.data.offer?.offerFiles?.forEach((file: any)=>{
                    if(file?.finalOfferWithUrl){
                        tempArray.push({id: file.id, fileUrl: file?.finalOfferWithUrl, name: file?.finalOfferName})
                    }else if(file?.pdfOfferWithUrl){
                        tempArray.push({id: file.id, fileUrl: file?.pdfOfferWithUrl, name: file?.pdfOfferName})
                    }else if(file?.requirementWithUrl){
                        tempArray.push({id: file.id, fileUrl: file?.requirementWithUrl, name: file?.requirementName})
                    }
                })
                setOfferAssets(tempArray)

                setLoading(false)
                setProductsLoading(false)
            }).catch((error: any) => {
                console.error('Error fetching offer details:', error)
                setLoading(false)
                setProductsLoading(false)
                toast.error(fm('offer.toast.somethingWentWrong', 'Something went wrong!'))
            })
        } else {
            resetFields()
            setLoading(false)
        }
    }

    // Push this offer to KuBIT as a sale order (proforma). Phase 1 is create-only.
    // The action returns a structured result — surface success vs the actionable
    // 422 (e.g. articles not yet synced to KuBIT) via toasts, and reflect the new
    // pushed status inline.
    async function handlePushToKubit(skipUnsynced: boolean = false) {
        if (!offerId) return
        setUnsyncedComponents([])
        setPushingToKubit(true)
        try {
            const result: any = await props.adminActions.pushKubitSaleOrder(Number(offerId), skipUnsynced)
            if (result?.ok) {
                const saleOrderId = result.sale_order_id || kubitSaleOrder?.saleOrderId || null
                setKubitSaleOrder({ pushed: true, saleOrderId })
                if (result.created) {
                    toast.success(fm('integrations.kubit.toast.offerPushed', 'Offer sent to KuBIT (sale order {id}).', { id: saleOrderId ?? '—' }))
                } else {
                    // Create-once: an already-pushed offer no-ops (the backend never
                    // returns updated:true — the in-place update path was removed).
                    toast.info(fm('integrations.kubit.toast.offerNoChange', 'No changes to send — KuBIT sale order {id} is up to date.', { id: saleOrderId ?? '—' }))
                }

                // Surface the manufacturing side-effects KuBIT created on this push
                // so auto-orders / skipped lines aren't silent.
                const k = result.kubit || {}
                const poCount = Array.isArray(k.purchaseOrders) ? k.purchaseOrders.length : 0
                if (k.productManufacturingId) {
                    toast.info(poCount > 0
                        ? fm('integrations.kubit.toast.manufacturingWithPo', 'Manufacturing order created · {count} purchase order(s) raised for short materials.', { count: poCount })
                        : fm('integrations.kubit.toast.manufacturing', 'Manufacturing order created in KuBIT.'))
                }
                const skips = (Array.isArray(k.warnings) ? k.warnings.length : 0)
                    + (Array.isArray(result.skipped_lines) ? result.skipped_lines.length : 0)
                if (skips > 0) {
                    toast.warn(fm('integrations.kubit.toast.pushSkipped', '{count} line(s) were skipped by KuBIT — check the integration log.', { count: skips }))
                }
            } else if (result) {
                // Raw-material components not synced to KuBIT — offer the "push without
                // them" choice (they'd be dropped from the recipe) instead of a dead-end.
                if (result.reason === 'components_not_synced' && Array.isArray(result.unsynced_components) && result.unsynced_components.length > 0) {
                    setUnsyncedComponents(result.unsynced_components)
                    return
                }
                const base = result.message || fm('integrations.kubit.toast.offerPushFailed', 'Failed to push the offer to KuBIT.')
                const unmappedArticles = Array.isArray(result.unmapped_articles) ? result.unmapped_articles.length : 0
                if (unmappedArticles > 0) {
                    toast.error(fm('integrations.kubit.toast.offerPushUnmapped', '{message} ({count} article(s) not yet synced to KuBIT.)', { message: base, count: unmappedArticles }))
                } else {
                    toast.error(base)
                }
            }
        } finally {
            setPushingToKubit(false)
        }
    }

    function offersForm() {
        return (
            <div className="offers-form-wrapper">
                <form className="offers-form container-fluid px-0" onSubmit={(e) => e.preventDefault()}>
                    {props.client?.client?.id && (
                        <div
                            className={`client-identity-strip${isDropDownInfoOpen ? ' is-open' : ''}`}
                            onClick={() => setIsDropDownInfoOpen(!isDropDownInfoOpen)}
                        >
                            <div className="client-avatar-initials">
                                {firstAndLastName?.charAt(0)?.toUpperCase() || '?'}
                            </div>
                            <div className="client-info-text">
                                <span className="client-info-label"><FormattedMessage id="offer.list.column.client" defaultMessage="Client" /></span>
                                <span className="client-info-name">{firstAndLastName}</span>
                            </div>
                            <img
                                className={`strip-arrow-icon${isDropDownInfoOpen ? ' rotated' : ''}`}
                                src={arrowDown}
                                alt=""
                            />
                        </div>
                    )}
                    {isDropDownInfoOpen && (
                        <div className="client-info-dropdown">
                            <DataTransferComponent clientId={props.client?.client?.id} measureNeeded/>
                        </div>
                    )}
                    {additionalOfferInputs()}
                </form>
            </div>
        )
    }

    const resetFields = () => {
        resetClient({
            id: undefined
        })
        resetOfferClient()
        setOfferStatus({
            label: '',
            value: undefined
        })
        setOfferAssets([])
        setAddition('')
        setAllOfferFields([])
        setFirstAndLastName('')
        setIsDropDownInfoOpen(false)
        productsLoadedFromUnified.current = false;
        // Reset new fields
        setPointOfContact({} as SelectOption)
        setInstallationDate(null)
        setOriginalInstallationDate(null)
        setIsOfferApproved(false)
        setInstallationDateHistory([])
        setShowInstallationHistory(false)
        setInstallationDateComment('')
        props.history.push('/dashboard/offers/create')
    }

    const OFFER_STATUS_I18N_KEY: Record<number, string> = {
        1: 'offer.status.rejected',
        2: 'offer.status.approved',
        3: 'offer.status.sent',
        4: 'offer.status.undefined',
        5: 'offer.status.pending',
    };

    const offerStatusOptions = useMemo(() => OFFER_STATUSES.map((s: any) => ({
        value: s.value,
        label: OFFER_STATUS_I18N_KEY[s.value]
            ? fm(OFFER_STATUS_I18N_KEY[s.value], s.label)
            : s.label,
    })), [props.intl]);

    const selectedOfferStatusOption = offerStatus?.value
        ? offerStatusOptions.find(o => o.value === offerStatus.value) || null
        : null;

    function saveDynamicOfferFields(name: string, inputElement: React.ChangeEvent<HTMLInputElement>, index: number) {
        let tempArrayOfOfferFields = [...allOfferFields]
        tempArrayOfOfferFields[index] = {
            ...tempArrayOfOfferFields[index],
            value: inputElement.target.value
        }
        setAllOfferFields(tempArrayOfOfferFields)
    }

    function removeFile(fileId){
        setLoading(true)
        props.actions.removeFile('offer', fileId).then(()=>{
            getModuleData()
        })
    }

    async function downloadSingleFile(file: any) {
        const token = localStorage.getItem('mikaBearerToken')
        // apiUrl imported from utils/apiCaller
        try {
            const response = await fetch(`${apiUrl}offers/assets/${file.id}/download`, {
                headers: { Authorization: `Bearer ${token}` }
            })
            if (!response.ok) throw new Error('failed')
            const blob = await response.blob()
            const objectUrl = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = objectUrl
            a.download = file.name
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
        } catch {
            toast.error(fm('offer.toast.downloadFailed', 'Download failed: {name}', { name: file.name }))
        }
    }

    function toggleSelectMode() {
        setIsSelectMode(prev => !prev)
        setSelectedAssets(new Set())
    }

    function toggleAssetSelection(id: number) {
        setSelectedAssets(prev => {
            const next = new Set(prev)
            if (next.has(id)) next.delete(id)
            else next.add(id)
            return next
        })
    }

    async function downloadSelected() {
        const files = (offerAssets as any[]).filter((a: any) => selectedAssets.has(a.id))
        const token = localStorage.getItem('mikaBearerToken')
        // apiUrl imported from utils/apiCaller

        for (const file of files) {
            try {
                const response = await fetch(`${apiUrl}offers/assets/${file.id}/download`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                if (!response.ok) throw new Error('failed')
                const blob = await response.blob()
                const objectUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = objectUrl
                a.download = file.name
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
            } catch {
                toast.error(fm('offer.toast.downloadFailed', 'Download failed: {name}', { name: file.name }))
            }
        }
    }

    async function confirmDeleteSelected() {
        setShowDeleteConfirm(false)
        setFilesLoading(true)
        try {
            if (pendingDeleteId != null) {
                await props.actions.removeFile('offer', pendingDeleteId)
                setPendingDeleteId(null)
            } else if (pendingBulkDeleteIds.length > 0) {
                for (const id of pendingBulkDeleteIds) {
                    await props.actions.removeFile('offer', id)
                }
                setPendingBulkDeleteIds([])
            } else {
                for (const id of Array.from(selectedAssets)) {
                    await props.actions.removeFile('offer', id)
                }
                setSelectedAssets(new Set())
                setIsSelectMode(false)
            }
            await refreshOfferFiles()
        } finally {
            setFilesLoading(false)
        }
    }

    function additionalOfferInputs() {
        const hasClient = !!props.client?.client?.id;
        const dateCommentVisible = !!(isOfferApproved && originalInstallationDate && (
            !installationDate || (installationDate && originalInstallationDate.getTime() !== installationDate.getTime())
        ));
        const hasHistory = installationDateHistory?.length > 0;

        return (
            <div className="offer-additional-wrapper">
                <div className="offer-page-layout">

                    {/* ── Left column ──────────────────────────────────────────── */}
                    <div className="offer-left-col">

                        {/* Required fields card */}
                        <div className="offer-required-card">
                            <div className="offer-card-header"><FormattedMessage id="offer.form.configHeader" defaultMessage="Offer configuration" /></div>
                            <div className="offer-fields-grid">
                                <div className="offer-field-item">
                                    <p className="small-text text-uppercase offer-title mb-1">
                                        <FormattedMessage id="offer.list.column.status" defaultMessage="Status"/>
                                    </p>
                                    <MikaSelect
                                        placeholder={fm('offer.form.selectOfferStatus', 'Select offer status')}
                                        options={offerStatusOptions}
                                        value={selectedOfferStatusOption}
                                        setEntireOptionFunction={setOfferStatus}
                                        clearable={false}/>
                                </div>
                                <div className="offer-field-item">
                                    <p className="small-text text-uppercase offer-title mb-1">
                                        <FormattedMessage id="offer.form.pointOfContact" defaultMessage="Project responsible"/>
                                    </p>
                                    <MikaSelect
                                        placeholder={fm('offer.form.selectPOC', 'Select point of contact')}
                                        options={pocUsers}
                                        value={pointOfContact}
                                        setEntireOptionFunction={setPointOfContact}/>
                                </div>
                                <div className="offer-field-item installationDateContainer">
                                    <p className="small-text text-uppercase offer-title mb-1">
                                        <FormattedMessage id="offer.form.installationDate" defaultMessage="Installation date"/>
                                    </p>
                                    <div className="dateContainer">
                                        <DatePicker
                                            selected={installationDate}
                                            onChange={(date: Date) => setInstallationDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText={fm('offer.form.selectDate', 'Pick date')}
                                            className="date-field-input"
                                            calendarClassName="modern-datepicker-calendar"
                                            popperPlacement="bottom"
                                            minDate={new Date()}
                                            isClearable
                                            {...{clearButtonClassName: "date-clear-btn"} as any}
                                            formatWeekDay={(d: string) => {
                                                const idx = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].indexOf(d);
                                                if (idx < 0) return d.charAt(0);
                                                const date = new Date(2000, 0, 2 + idx);
                                                return new Intl.DateTimeFormat(props.intl.locale, { weekday: 'narrow' }).format(date);
                                            }}
                                            renderCustomHeader={(p: any) => <CalendarHeader {...p} />}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Date change comment — amber warning */}
                        {dateCommentVisible && (
                            <div className="date-change-comment-card">
                                <p className="small-text text-uppercase offer-title mb-1">
                                    {!installationDate
                                        ? <FormattedMessage id="offer.form.deleteReasonLabel" defaultMessage="Reason for removal (required)" />
                                        : <FormattedMessage id="offer.form.changeReasonLabel" defaultMessage="Reason for change (required)" />}
                                </p>
                                <textarea
                                    className="date-comment-textarea"
                                    rows={3}
                                    value={installationDateComment}
                                    onChange={(e) => setInstallationDateComment(e.target.value)}
                                    placeholder={!installationDate
                                        ? fm('offer.form.deleteReasonPlaceholder', 'Enter the reason for removing the date...')
                                        : fm('offer.form.changeReasonPlaceholder', 'Enter the reason for changing the date...')}
                                />
                            </div>
                        )}

                        {/* Date change history */}
                        {hasHistory && (
                            <div className="date-history-section">
                                <button
                                    type="button"
                                    className="date-history-toggle"
                                    onClick={() => setShowInstallationHistory(!showInstallationHistory)}
                                >
                                    <span className="history-toggle-icon">{showInstallationHistory ? '▼' : '▶'}</span>
                                    <FormattedMessage id="offer.form.dateHistory" defaultMessage="Date history" /> ({installationDateHistory.length})
                                </button>
                                {showInstallationHistory && (
                                    <div className="date-history-list">
                                        {installationDateHistory.map((item, index) => (
                                            <div key={index} className="history-item">
                                                <div className="history-row"><span className="history-label"><FormattedMessage id="offer.form.dateLabel" defaultMessage="Date:" /></span> {item.installationDate}</div>
                                                <div className="history-row"><span className="history-label"><FormattedMessage id="offer.form.changedBy" defaultMessage="Changed by:" /></span> {item.changedByUser}</div>
                                                <div className="history-row"><span className="history-label"><FormattedMessage id="offer.form.when" defaultMessage="When:" /></span> {item.changedAt}</div>
                                                {item.comment && <div className="history-row"><span className="history-label"><FormattedMessage id="offer.form.commentLabel" defaultMessage="Comment:" /></span> {item.comment}</div>}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Dynamic offer fields */}
                        {allOfferFields?.length > 0 && (
                            <div className="offer-dynamic-card">
                                <div className="offer-card-header"><FormattedMessage id="offer.form.additionalFields" defaultMessage="Additional fields" /></div>
                                <div className="offer-dynamic-grid">
                                    {allOfferFields.map((offerField, index) => (
                                        <div key={index} className="offer-dynamic-field">
                                            <label className="offer-dynamic-label">{offerField?.name}</label>
                                            <input
                                                className="offer-dynamic-input"
                                                name={offerField?.name}
                                                value={offerField?.value || ''}
                                                type="text"
                                                placeholder={offerField?.name}
                                                onChange={(inputElement: React.ChangeEvent<HTMLInputElement>) => saveDynamicOfferFields(offerField.name, inputElement, index)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Comments */}
                        {offerId && (
                            <div className="offer-comments-section">
                                <div className="agr-section-title" style={{ background: '#1e3a5f', color: '#fff', borderRadius: '10px 10px 0 0', padding: '10px 16px', fontSize: '12px', fontWeight: 600, textTransform: 'uppercase' as any, letterSpacing: '0.4px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <FormattedMessage id="offer.form.commentsSection" defaultMessage="Comments" />
                                    {offerComments.length > 0 && <span style={{ background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: 10, fontSize: 10, fontWeight: 700 }}>{offerComments.length}</span>}
                                </div>
                                <div style={{ border: '1px solid #e2e8f0', borderTop: 'none', borderRadius: '0 0 10px 10px', padding: 16 }}>
                                    <div className="agr-comments" style={{ maxHeight: 300, overflowY: 'auto', marginBottom: 12 }}>
                                        {offerComments.length === 0 && (
                                            <div className="agr-comments-empty" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '24px 0' }}>
                                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>
                                                <span style={{ fontSize: 12, color: '#94a3b8' }}><FormattedMessage id="offer.form.noCommentsYet" defaultMessage="No comments yet" /></span>
                                            </div>
                                        )}
                                        {offerComments.map(c => {
                                            const initials = (c.user || '??').split(' ').map((w: string) => w.charAt(0)).join('').substring(0, 2).toUpperCase();
                                            const colors = ['#3b82f6', '#8b5cf6', '#06b6d4', '#f59e0b', '#ef4444', '#22c55e', '#ec4899', '#6366f1'];
                                            let hash = 0;
                                            for (let i = 0; i < (c.user || '').length; i++) hash = (c.user || '').charCodeAt(i) + ((hash << 5) - hash);
                                            const avatarColor = colors[Math.abs(hash) % colors.length];
                                            return (
                                                <div key={c.id} className="agr-comment">
                                                    <div className="agr-comment-avatar" style={{ background: avatarColor }}>{initials}</div>
                                                    <div className="agr-comment-content">
                                                        <div className="agr-comment-meta">
                                                            <span className="agr-comment-user">{c.user}</span>
                                                            <span className="agr-comment-dot">&middot;</span>
                                                            <span className="agr-comment-date">{c.createdAt}</span>
                                                        </div>
                                                        <div className="agr-comment-body"><MentionText text={c.comment} /></div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className="agr-comment-input-wrap">
                                        <MentionInput
                                            multiline
                                            value={newOfferComment}
                                            onChange={(next) => setNewOfferComment(next)}
                                            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleAddOfferComment(); }}}
                                            placeholder={fm('offer.form.writeAComment', 'Write a comment...')}
                                            rows={2}
                                        />
                                        <button className="agr-comment-send" onClick={handleAddOfferComment} disabled={!newOfferComment.trim()} type="button" title={fm('offer.form.sendComment', 'Send')}>
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* ── Right sticky column ──────────────────────────────────── */}
                    {hasClient && (
                        <div className="offer-right-col">
                            <div className="offer-right-sticky">

                                {/* Single unified card: upload + files */}
                                <div className="offer-right-card">
                                    <div className="offer-card-header"><FormattedMessage id="offer.form.offerDocuments" defaultMessage="Offer documents" /></div>

                                    {/* Upload section */}
                                    <div className="offer-upload-section">
                                        <Button
                                            isLoading={openingModal || props?.buttonLoader}
                                            isDisabled={openingModal || props?.buttonLoader}
                                            onClick={openModalWithFreshData}
                                            submit={true}
                                            className="ml-0 calculateOfferModalButton w-100 align-items-center"
                                            buttonType={EButtonType.BasicLink}>
                                            <FormattedMessage id="offer.form.createOffer" defaultMessage="Create offer"/>
                                            <FontAwesome name="calculator" className="me-4"/>
                                        </Button>
                                        <MikaFileInput
                                            labelKey={fm('offer.form.addPDF', 'Add PDF')}
                                            multiple setFiles={setPdfFile} className="w-100" accept={".pdf"}/>
                                        <MikaFileInput
                                            labelKey={fm('offer.form.addFinalOffer', 'Add final offer')}
                                            multiple setFiles={setFinalOfferFile} className="w-100"/>
                                        <MikaFileInput
                                            labelKey={fm('offer.form.addRequirements', 'Add requirements')}
                                            multiple setFiles={setRequirementsFile} className="w-100"/>
                                    </div>

                                    {/* Files section */}
                                    {offerAssets?.length > 0 && (
                                        <MikaFileManager
                                            files={(offerAssets || []).map((a: any) => ({ id: a.id, name: a.name, url: a.fileUrl }))}
                                            loading={filesLoading}
                                            onDelete={(fileId) => {
                                                setPendingDeleteId(fileId);
                                                setPendingBulkDeleteIds([]);
                                                setShowDeleteConfirm(true);
                                            }}
                                            onBulkDelete={(ids) => {
                                                setPendingDeleteId(null);
                                                setPendingBulkDeleteIds(ids);
                                                setShowDeleteConfirm(true);
                                            }}
                                        />
                                    )}

                                    {/* Save button — card footer */}
                                    {((!props.permissions.observer) || props.permissions.fullPrivileges) && (
                                        <div className="offer-card-footer">
                                            <Button
                                                isLoading={props?.buttonLoader}
                                                isDisabled={props?.buttonLoader}
                                                submit={true}
                                                className="button-save-offer w-100"
                                                onClick={saveOfferData}
                                                buttonType={EButtonType.GreyButton}>
                                                {props.offers.offerClient?.id ?
                                                    <FormattedMessage id="offer.form.saveOffer" defaultMessage="Save offer"/> :
                                                    <FormattedMessage id="offer.form.processOffer" defaultMessage="Process offer"/>
                                                }
                                            </Button>
                                            {offerId && props.companyProfile?.kubitEnabled && (props.permissions?.fullPrivileges || props.permissions?.manageIntegrations) && (
                                                <>
                                                    {kubitSaleOrder?.pushed ? (
                                                        // Create-once: an approved offer posts to KuBIT exactly once (KuBIT
                                                        // has no update-saleorder endpoint), so once pushed we only show status.
                                                        <p className="kubit-saleorder-status">
                                                            <FormattedMessage
                                                                id="integrations.kubit.offer.pushedStatus"
                                                                defaultMessage="Pushed to KuBIT · #{id}"
                                                                values={{ id: kubitSaleOrder.saleOrderId ?? '—' }}
                                                            />
                                                        </p>
                                                    ) : isOfferApproved ? (
                                                        <Button
                                                            isLoading={pushingToKubit}
                                                            isDisabled={pushingToKubit || props?.buttonLoader}
                                                            onClick={() => handlePushToKubit()}
                                                            className="button-push-kubit w-100 mt-2"
                                                            buttonType={EButtonType.PurpleButton}>
                                                            {pushingToKubit
                                                                ? <FormattedMessage id="integrations.kubit.offer.pushing" defaultMessage="Sending…" />
                                                                : <FormattedMessage id="integrations.kubit.offer.push" defaultMessage="Push to KuBIT" />}
                                                        </Button>
                                                    ) : (
                                                        // Gated: only an APPROVED offer can be sent (backend requires approved_at).
                                                        <p className="kubit-approval-hint mt-2">
                                                            <FormattedMessage
                                                                id="integrations.kubit.offer.approveFirst"
                                                                defaultMessage="Approve this offer to send it to KuBIT." />
                                                        </p>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Offer conditions — full width below both columns */}
                {(offerConditions && offerConditions.replace(/<[^>]*>/g, '').trim().length > 0) && (
                    <div className="offerConditions">
                        <div className="offer-conditions-title">
                            <FormattedMessage id="offer.form.conditionsTitle" defaultMessage="Offer terms" />
                        </div>
                        <div dangerouslySetInnerHTML={{__html: offerConditions}}/>
                    </div>
                )}
            </div>
        )
    }

    const saveOfferData = async () => {
        // console.log(props.offers, 'asdasdasdasdasd')
        // return

        // Check if this is an existing offer (has ID in the database)
        const isExistingOffer = !!props.offers.offerClient?.id;

        // Check if products exist in local state (at least one product with an ID)
        const hasLocalProducts = products?.length > 0 && (products.length > 1 || products[0]?.id);

        // For existing offers, we trust that products exist in the backend already
        // (the user may not have opened the modal, so local products state might not be populated)
        // Only validate products for NEW offers
        if (!isExistingOffer && !hasLocalProducts) {
            // New offer - must have products in local state
            toast.info(fm('offer.toast.createProductsForOffer', 'Please create products for this offer.'))
            return
        }

        // Frontend validation: Check if installation date is not in the past (only if date was changed)
        if (installationDate) {
            const dateWasChanged = !originalInstallationDate || originalInstallationDate.getTime() !== new Date(installationDate).getTime();
            if (dateWasChanged) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const selectedDate = new Date(installationDate);
                selectedDate.setHours(0, 0, 0, 0);

                if (selectedDate < today) {
                    toast.error(fm('offer.toast.dateCannotBeInPast', 'The installation date cannot be in the past.'));
                    return;
                }
            }
        }

        // Frontend validation: Check if comment is required for installation date changes on approved offers
        if (isOfferApproved && originalInstallationDate) {
            const dateWasCleared = !installationDate;
            const dateWasChanged = installationDate && originalInstallationDate.getTime() !== installationDate.getTime();

            if ((dateWasCleared || dateWasChanged) && !installationDateComment?.trim()) {
                if (dateWasCleared) {
                    toast.error(fm('offer.toast.commentRequiredDelete', 'A comment is required when removing the installation date after approval.'));
                } else {
                    toast.error(fm('offer.toast.commentRequiredChange', 'A comment is required when changing the installation date after approval.'));
                }
                return;
            }
        }

        let payload = new FormData();
        setLoading(true)
        payload.append("id", props.offers.offerClient?.id);
        payload.append("clientId", props.client?.client?.id);
        if (offerStatus?.value) {
            payload.append("offerStatusId", offerStatus?.value);
        }
        if (props.client.client.address) {
            payload.append("address", props.client.client.address);
        }
        if (addition) {
            payload.append("addition", addition);
        }
        if (props.offers?.offerId) {
            payload.append("offerId", props.offers?.offerId);
        }
        if((props.offers?.discountType?.value == 0 || props.offers?.discountType?.value == 1) && props.offers?.discountValue){
            if(props.offers?.discountType?.value == 0 || props.offers?.discountType?.value == 1){
                payload.append("discountType", `${props.offers?.discountType?.value}` || '')
            }
            if(props.offers?.discountTotal){
                payload.append("discountTotal", `${props.offers?.discountTotal}` || '')
            }
            if(props.offers?.discountValue){
                payload.append("discountValue", props.offers?.discountValue || '')
            }
        }
        allOfferFields?.forEach((offerField) => {
            if (offerField?.id) {
                payload.append('dynamicFieldIds[]', String(offerField.id));
                payload.append('dynamicFieldValues[]', offerField?.value ?? '');
            }
        })

        // Add Point of Contact
        if (pointOfContact?.value) {
            payload.append("pointOfContactUserId", pointOfContact.value.toString());
        }

        // Add Installation Date (convert Date object to dd/mm/yyyy)
        if (installationDate) {
            const formattedDate = moment(installationDate).format('DD/MM/YYYY');
            payload.append("installationDate", formattedDate);
        } else if (originalInstallationDate && !installationDate) {
            // Date is being cleared - send flag to backend
            payload.append("clearInstallationDate", "1");
        }

        // Add Installation Date Comment (required when changing date on approved offer)
        if (installationDateComment) {
            payload.append("installationDateComment", installationDateComment);
        }
        if(finalOfferFile.length !== 0){
            finalOfferFile.forEach((file)=>{
                payload.append("finalOffer[]", file.file);
            })
        }
        if(requirementsFile.length !== 0){
            requirementsFile.forEach((file)=>{
                payload.append("requirement[]", file.file);
            })
        }
        if(pdfFile.length !== 0){
            pdfFile.forEach((file)=>{
                payload.append("pdfOffer[]", file.file);
            })
        }
        if (props.offers.comment) {
            payload.append("comment", props.offers.comment);
        }
        if (props.offers.offerClient?.id) {
            props.offerActions.editOffer(payload).then((res) => {
                // Only navigate on successful response - check if res exists and has data
                if (!res || !res.data) {
                    // No response data means error was handled somewhere
                    setLoading(false)
                    return
                }
                if (res.data?.cantEdit) {
                    toast.error(fm('offer.toast.clientInAgreement', 'This client is already in the agreements module.'))
                    setLoading(false)
                    return
                }
                // Success - navigate back
                props?.history?.goBack()
                setLoading(false)
            }).catch((err: any) => {
                // Error is already handled in the action with toast
                // Stay on the current page - don't navigate
                setLoading(false)
            })
        } else {
            props.offerActions.createOffer(payload).then((res) => {
                // Only navigate on successful response
                if (!res) {
                    setLoading(false)
                    return
                }
                props?.history?.goBack()
                setLoading(false)
            }).catch((err: any) => {
                setLoading(false)
            })
        }
        setIsDropDownInfoOpen(false)
    }

    const refreshOfferFiles = async () => {
        try {
            const response: any = await apiCaller('GET', `offers/${offerId}/complete-details`);
            const res = response;
            let tempArray = []
            res.data.offer?.offerFiles?.forEach((file: any) => {
                if (file?.finalOfferWithUrl) {
                    tempArray.push({id: file.id, fileUrl: file?.finalOfferWithUrl, name: file?.finalOfferName})
                } else if (file?.pdfOfferWithUrl) {
                    tempArray.push({id: file.id, fileUrl: file?.pdfOfferWithUrl, name: file?.pdfOfferName})
                } else if (file?.requirementWithUrl) {
                    tempArray.push({id: file.id, fileUrl: file?.requirementWithUrl, name: file?.requirementName})
                }
            })
            setOfferAssets(tempArray)
        } catch {
            // silently ignore — files will be visible on next page reload
        }
    }

    return (
        <div className="wrapper">
            {loading ?
                <div style={{display: "block", height: "calc(100vh - 130px)"}}>
                    <Spinner/>
                </div> :
                offersForm()
            }
            {isDeleteModalOpen && <CalculateOfferModal products={products} setProducts={setProducts} productsLoading={productsLoading} setProductsLoading={setProductsLoading} getProductsOfClient={getProductsOfClient} closeModalFunction={setDeleteModal} projectDetails={props.projectDetails} onPdfSaved={refreshOfferFiles} onOfferSaved={getModuleData}/>}
            {showDeleteConfirm && (
                <div className="delete-confirm-overlay">
                    <div className="delete-confirm-box">
                        <p className="delete-confirm-title"><FormattedMessage id="offer.deleteConfirm.title" defaultMessage="Are you sure?" /></p>
                        <p className="delete-confirm-msg">
                            {pendingDeleteId != null
                                ? <FormattedMessage id="offer.deleteConfirm.single" defaultMessage='Do you want to delete "{name}"?' values={{ name: (offerAssets as any[]).find((a: any) => a.id === pendingDeleteId)?.name }} />
                                : pendingBulkDeleteIds.length > 0
                                    ? <FormattedMessage id="offer.deleteConfirm.bulk" defaultMessage="Do you want to delete {count, plural, one {# file} other {# files}}?" values={{ count: pendingBulkDeleteIds.length }} />
                                    : selectedAssets.size === 1
                                        ? <FormattedMessage id="offer.deleteConfirm.selectedSingle" defaultMessage="Do you want to delete this file?" />
                                        : <FormattedMessage id="offer.deleteConfirm.selectedMany" defaultMessage="Do you want to delete {count} files?" values={{ count: selectedAssets.size }} />}
                        </p>
                        <div className="delete-confirm-actions">
                            <button type="button" className="confirm-btn cancel" onClick={() => { setShowDeleteConfirm(false); setPendingDeleteId(null); setPendingBulkDeleteIds([]) }}><FormattedMessage id="common.confirm.cancel" defaultMessage="Cancel" /></button>
                            <button type="button" className="confirm-btn confirm" onClick={confirmDeleteSelected}><FormattedMessage id="offer.deleteConfirm.confirmDelete" defaultMessage="Delete" /></button>
                        </div>
                    </div>
                </div>
            )}

            {/* KuBIT: raw materials not synced → let the user sync first or push without them. */}
            <MikaConfirmModal
                isOpen={unsyncedComponents.length > 0}
                onClose={() => setUnsyncedComponents([])}
                onConfirm={() => handlePushToKubit(true)}
                title={fm('integrations.kubit.unsynced.title', 'Some raw materials aren\'t synced')}
                message={
                    <>
                        <FormattedMessage id="integrations.kubit.unsynced.message" defaultMessage="These raw materials aren't synced with KuBIT yet:" />
                        <br />
                        <strong>{unsyncedComponents.join(', ')}</strong>
                        <br /><br />
                        <FormattedMessage id="integrations.kubit.unsynced.choice" defaultMessage="Sync them first, or push the offer without them (they won't be part of the KuBIT recipe)." />
                    </>
                }
                confirmLabel={fm('integrations.kubit.unsynced.pushAnyway', 'Push without them')}
                confirmColor="primary"
            />
        </div>
    )
}

function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        client: state.client,
        measures: state.measures,
        offers: state.offers,
        admin: state.admin
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        measuresActions: bindActionCreators(measuresActions as any, dispatch),
        offerActions: bindActionCreators(offerActions as any, dispatch),
        clientActions: bindActionCreators(clientActions as any, dispatch),
        actions: bindActionCreators(actions as any, dispatch),
        adminActions: bindActionCreators(adminActions as any, dispatch),
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(Offers as any)));